import { render } from "./ExploreNewestItem.vue?vue&type=template&id=0edfe2d9"
import script from "./ExploreNewestItem.vue?vue&type=script&lang=js"
export * from "./ExploreNewestItem.vue?vue&type=script&lang=js"

import exportComponent from "/Users/leonardoprado/Documents/My Projects/Natalia/nuron-nft-vue-js-template-2024-03-07-14-00-41-utc/nuron-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__